
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
}
